import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsArtworkStartedMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsArtworkStarted(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...ArtOrderStatus_order
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default markOrderAsArtworkStartedMutation;
